import React from 'react';
import { CardMedia,IconButton, Box, TextField, List, Typography, Container } from '@material-ui/core/';

import 'react-gallery-carousel/dist/index.css'
import { makeStyles } from '@material-ui/core/styles';
import {
    PlusCircle as PlusIcon,
    MinusCircle as MinusIcon
} from "react-feather";

const useStyles = makeStyles(() => ({
    option: {
        width: "100%",
        display: "inline-flex",
        flexDirection: "row",
        marginTop: "1auto",
        borderRadius: "6px",
        justifyContent: "center",
        alignItems: "top",
        verticalAlign: "middle",
        marginBottom: "0.5rem",
        justifyContent: "top"
    },
    optionResponsive: {
        width: "100%",
        display: "flex",
        flexWrap: "wrap",
        flexDirection: "row",
        marginTop: "1auto",
        borderRadius: "6px",
        justifyContent: "center",
        alignItems: "center",
        verticalAlign: "middle",
        marginBottom: "0.5rem",
        paddingRight: 0,
        paddingLeft: 0
    },
    media: {
            width: "25%",
    height: "100px",
    marginRight: "16px",
    borderRadius: "4px",
    },
    detailUnits: {
        display: "inline-flex",
        webkitBoxOrient: "vertical",
        webKitBoxDirection: "normal",
        webkitFlexDirection: "column",
        flexDirection: "column",
        webkitBoxAlign: "top",
        webkitAlignItems: "top",
        alignItems: "top",
        textAlign: "center",
        alignSelf: "center",
        paddingLeft: "5px"
    }, personsTextField: {
        marginRight: "1rem"
    },
    optionsList: {
        paddingTop: "0px",
        paddingBottom: "0px"
    },
    optionContainer: {
        display: "flex",
        flexDirection: "column",
        paddingLeft: 0,
        paddingRight: 0
    },
    optionTitle: {
        paddingLeft: "0px",
        fontWeight: "bold",
        fontSize: "18px"
    },
    optionDescription: {
        fontSize: "18px"
    },
    optionValue: {
        fontSize: "15px",
        padding: "0px",
        minWidth: "90px",
        alignSelf: "center"
    },
    optionTotal: {
        fontSize: "15px",
        paddingLeft: "20px",
        paddingRight: "0px",
        minWidth: "90px",
        textAlign: "center",
        fontWeight: "bold",
        alignSelf: "center"
    },
    selectUnitsContainer: {
        display: "flex",
        wrap: "nowrap",
        paddingTop: "5px",
        paddingLeft: 0,
        paddingRight: 0
    },
    unitsTextField: {
        alignSelf: "center"
    }
}));

const SelectOption = (props) => {
    const { option, maxUnits, fullScreen } = props;

    const classes = useStyles();

    const onPlusClicked = () => {
            const newQuantity = quantity + 1;
            setQuantity(newQuantity)
            option.quantity = newQuantity
        }
        const onMinusClicked = () => {
            if (quantity > 0) {
                const newQuantity = quantity - 1;
                setQuantity(newQuantity)
                option.quantity = newQuantity
            }
        }

    
    const [quantity, setQuantity] = React.useState(option.quantity ? option.quantity : 0);
    
 function isTransfer(option) {
        return option && option.name && option.name.toLowerCase().includes("transfer")
    }

        return (
            <React.Fragment key={option.name}>
                <Box className={fullScreen ? classes.optionResponsive : classes.option}>
                    {fullScreen ? "": 
                        <CardMedia
                            className={classes.media}
                            image={option.photoUrl}
                            title={option.name}
                        />}
                    <Container className={classes.optionContainer}>
                        <Typography className={classes.optionTitle}>{option.name}</Typography>
                        <Typography className={classes.optionDescription} dangerouslySetInnerHTML={{ __html: option.description }} />
                    </Container>
                    <Container className={classes.selectUnitsContainer}>
                        <Typography
                            className={classes.optionValue}>{(option.value * 1.10).toFixed(2) + " €/ud"}</Typography>
                        <TextField
                            type="number"
                            className={classes.unitsTextField}
                            color="secondary"
                            variant="outlined"
                            InputLabelProps={{
                                shrink: true
                            }}
                            placeholder="unidades"
                            value={quantity} />

                        <div className={classes.detailUnits}>
                            <IconButton size="small" onClick={onPlusClicked}
                                disabled={maxUnits >= 0 && maxUnits === quantity}><PlusIcon /></IconButton>
                            <IconButton size="small" onClick={onMinusClicked}
                                disabled={quantity === 0}><MinusIcon /></IconButton>
                        </div>
                        <Typography className={classes.optionTotal}>
                            {
                                quantity
                                    ? ((option.value * quantity * 1.1).toFixed(2) + " €")
                                    : "0.00 €"
                            }
                        </Typography>
                    </Container>
                </Box>
            </React.Fragment>
        )
    };


export default SelectOption;
